import styled from "@emotion/styled";

export const DropdownMenu = styled.div`
  border: ${p => p.theme.borders.browserInfoTable};
  border-radius: ${p => p.theme.radii.small};

  @media screen and (min-width: ${p => p.theme.screenSizes.mdMax}) {
    display: none;
  }
`;

export const DropdownWrapper = styled.div`
  :not(:last-child) {
    border-bottom: ${p => p.theme.borders.browserInfoTable};
  }
`;

export const DropdownHeaderWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;

  cursor: pointer;
  -webkit-tap-highlight-color: rgba(255, 255, 255, 0);
`;

export const DropdownHeaderTitle = styled.p`
  margin: 0;
  padding: 14px 12px;

  text-align: left;
  font-size: ${p => p.theme.fontSizes.m};
  font-weight: ${p => p.theme.fontWeight.medium};
  color: ${p => p.theme.colors.secondary.gray};
`;

export const DropdownItemWrapper = styled.div`
  padding: ${({ isOpen }) => (isOpen ? "12px 16px" : "0 16px")};
  background-color: ${p => p.theme.colors.background};
  height: ${({ isOpen }) => (isOpen ? "auto" : "0")};
  overflow: hidden;
  transition:
    height 0.3s ease,
    padding 0.3s ease;
`;

export const Icon = styled.img`
  padding: ${p => p.theme.space[3]}px;
  cursor: pointer;

  transform: ${({ isOpen }) => (isOpen ? "rotate(180deg)" : "rotate(0deg)")};
  transition: transform 0.3s ease;
`;
